// En desarrollo usa la variable de entorno (NEXT_PUBLIC_ es necesario para componentes cliente)
// En producción usa el valor fijo como fallback
export const UNIVEN_PUBLIC_HOST =
  process.env.UNIVEN_HOST_PUBLIC || "https://crm.univenweb.com.br";
